import Util from '../../../shared/util/util';
import DirectApi from '../../../../directApi';

export const INVOICE_INTEGRATIONS = {
	XERO: 'XERO',
	ECONOMIC: 'ECONOMIC',
	QUICKBOOKS: 'QUICKBOOKS',
};

export type Contact = {
	id: string;
	name: string;
	address?: string;
	taxId?: string;
	integrationInstanceId?: string;
	integration: string;
};

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
const defaultContactsMapper = (customers: any[], integrationName: string): Contact[] =>
	!Array.isArray(customers)
		? []
		: customers
				.sort((a, b) => Util.sortAlphabetically(a.name, b.name))
				.map(customer => ({
					id: String(customer.id),
					name: customer.name,
					taxId: String(customer.taxId),
					address: customer.address,
					integrationInstanceId: customer.integrationInstanceId,
					integration: integrationName,
				}));

export const fetchXeroContacts = (): Promise<Contact[]> =>
	DirectApi.Fetch('xero/allContacts').then(customers => defaultContactsMapper(customers, INVOICE_INTEGRATIONS.XERO));
export const fetchQuickbooksContacts = (): Promise<Contact[]> =>
	DirectApi.Fetch('quickbooks/all_customers').then(customers =>
		defaultContactsMapper(customers, INVOICE_INTEGRATIONS.QUICKBOOKS)
	);
export const fetchEconomicContacts = (): Promise<Contact[]> =>
	DirectApi.Fetch('economic/all_customers').then(customers =>
		defaultContactsMapper(customers, INVOICE_INTEGRATIONS.ECONOMIC)
	);

export const filterContactsByIntegrationInstanceId = (
	contacts: Contact[],
	billFrom?: {
		integration?: string;
		externalId?: string;
	} | null
): Contact[] =>
	contacts.filter(
		contact =>
			(!contact.integrationInstanceId || contact.integrationInstanceId === billFrom?.externalId) &&
			contact.integration === billFrom?.integration
	);
